import { apiClient } from "./apiClient";

const auth = (t) => ({ headers: { Authorization: `Bearer ${t}` } });

export const getEdgeOta = async (t, edgeDbId) => (await apiClient.get(`/edges/${edgeDbId}/ota`, auth(t))).data;

export const approveEdgeOta = async (t, edgeDbId, { release_id, window_start, window_end }) =>
  (await apiClient.post(`/edges/${edgeDbId}/ota-approval`, { release_id, window_start, window_end }, auth(t))).data;

export const revokeEdgeOta = async (t, edgeDbId, releaseId) =>
  (await apiClient.delete(`/edges/${edgeDbId}/ota-approval/${releaseId}`, auth(t))).data;

export const bulkApproveOta = async (t, { edge_ids, release_id, window_start, window_end }) =>
  (await apiClient.post("/edges/ota-approvals/bulk", { edge_ids, release_id, window_start, window_end }, auth(t))).data;

export const setEdgeOtaChannel = async (t, edgeDbId, channel) =>
  (await apiClient.patch(`/edges/${edgeDbId}/ota-channel`, { channel }, auth(t))).data;

export const setEdgeOtaCritical = async (t, edgeDbId, requireLocalApproval) =>
  (await apiClient.patch(`/edges/${edgeDbId}/ota-critical`, { require_local_approval: requireLocalApproval }, auth(t))).data;
